import styles from './Field.module.css';

/**
 * Control styles shared by `Input`, `Textarea` and `Select`, so all three
 * render an identical box without one importing another's module.
 */
export const fieldStyles = styles;
